import GenerateMemberCardsServices from './GenerateMemberCardsServices';
import GenerateMemberCardsServicesMock from './GenerateMemberCardsServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? GenerateMemberCardsServicesMock : GenerateMemberCardsServices;
